import MainLayout from '@/components/layouts/main-layout';
import {useRouter} from 'next/router';

export default function TermsOfServicePage() {
  const {locale} = useRouter();
  return (
    <MainLayout metadata={{title: 'Terms of Service - Soubul'}}>
      <div className="flex flex-1 items-center justify-center">
        {locale === 'ar' ? <ArabicTermsOfService /> : <EnglishTermsOfService />}
      </div>
    </MainLayout>
  );
}

function EnglishTermsOfService() {
  return (
    <div className="bg-white border rounded-lg text-center my-12 px-6 py-12">
      <h1 className="text-3xl mb-12">Terms and Conditions</h1>
      <div className="container mx-auto text-justify" style={{maxWidth: '720px'}}>
        <span className="font-semibold block mb-4">WEBSITE USER AGREEMENT FOR SOUBUL ACADEMY</span>
        <span className="font-semibold block mb-4">
          PLEASE READ THIS DOCUMENT CAREFULLY BEFORE ACCESSING OR USING SOUBUL.COM WEBSITE.
        </span>
        <span className="block mb-6 text-sm">
          BY ACCESSING OR USING THE SITE, YOU AGREE TO BE BOUND BY THE TERMS AND CONDITIONS SET FORTH BELOW. IF YOU DO
          NOT WISH TO BE BOUND BY THESE TERMS AND CONDITIONS, YOU MAY NOT ACCESS OR USE THE SITE AND SHOULD IMMEDIATELY
          CEASE SUCH USE. SOUBUL ACADEMY MAY MODIFY THIS AGREEMENT AT ANY TIME, AND SUCH MODIFICATIONS SHALL BE
          EFFECTIVE IMMEDIATELY UPON POSTING OF THE MODIFIED AGREEMENT ON THE SITE. YOU AGREE TO REVIEW THE AGREEMENT
          PERIODICALLY TO BE AWARE OF SUCH MODIFICATIONS AND YOUR CONTINUED ACCESS OR USE OF THE SITE SHALL BE DEEMED
          YOUR CONCLUSIVE ACCEPTANCE OF THE MODIFIED AGREEMENT.
        </span>

        <span className="block mb-4 font-semibold">BASIC TERMS</span>
        <span className="block mb-6 text-sm">
          DEFINITION OF SOME TERMS THAT MAY BE CONTAINED IN THESE TERMS AND CONDITIONS UNLESS THE CONTEXT OF THE TERMS
          AND CONDITIONS REQUIRES OTHERWISE:
        </span>

        <span className="block mb-4 font-semibold">SOUBUL ACADEMY:</span>
        <span className="block mb-6 text-sm">
          IT IS A WHOLLY OWNED PLATFORM OF SOBOL ACADEMY LTD., WHICH PROVIDES SERVICES TO THOSE LOOKING FOR SUPPORTIVE
          LESSONS FROM SERVICE PROVIDERS.
        </span>

        <span className="block mb-4 font-semibold">USER:</span>
        <span className="block mb-6 text-sm">IS THE SEEKER FOR SUPPORTING LESSONS SERVICES.</span>

        <span className="block mb-4 font-semibold">SERVICE PROVIDER:</span>
        <span className="block mb-6 text-sm">IT IS A PROVIDER OF TUTORING SERVICES.</span>

        <span className="block mb-4 font-semibold">THE THIRD PARTY:</span>
        <span className="block mb-6 text-sm">
          IT IS ANY MEDIA, COMMERCIAL, OR PROMOTIONAL INTERMEDIARY, OR ANY COMPANY OR GOVERNMENTAL OR PRIVATE ENTITY
          ASSOCIATED WITH THE SOUBUL ACADEMY WEBSITE WITH CONTRACTS TO SUPPLY OR OBTAIN SERVICES OR MAKE PUBLICITY OR
          ADVERTISING OR ACTIVITIES OR ANYTHING THAT WOULD CONTRIBUTE TO THE SERVICES OF THE ACADEMY SITE PREVIOUS WAYS
          DEFINED IN THIS SAME CLAUSE.
        </span>

        <span className="block mb-4 font-semibold">DATA DOCUMENTATION</span>
        <span className="block mb-6">
          IN ORDER FOR US TO VERIFY YOUR MOBILE NUMBER, AS STIPULATED IN THE TERMS OF USE THAT APPEARS WHEN YOU FIRST
          REGISTER ON THE SOUBUL ACADEMY WEBSITE, YOU WILL BE REQUIRED TO ENTER A USERNAME, MOBILE NUMBER AND AN ACTIVE
          EMAIL ADDRESS. THEN YOU WILL SEND A TEXT MESSAGE TO YOUR MOBILE NUMBER WITH AN ACTIVATION CODE. WHEN YOU CLICK
          ON THIS LINK, YOUR MOBILE NUMBER AND EMAIL ADDRESS WILL BE VERIFIED DIRECTLY, AND YOU WILL BE REDIRECTED TO
          THE SOUBUL ACADEMY WEBSITE.
        </span>

        <span className="block mb-4 font-semibold">1. Copyright, Licenses, and Idea Submissions</span>
        <span className="block mb-6 text-sm">
          Domestic and International copyright and trademark laws protect the entire contents of the Site. The owners of
          the intellectual property, copyrights and trademarks are SOUBUL ACADEMY or other third-party licensors. YOU
          MAY NOT MODIFY, COPY, REPRODUCE, REPUBLISH, UPLOAD, POST, TRANSMIT, OR DISTRIBUTE, IN ANY MANNER, THE MATERIAL
          ON THE SITE, INCLUDING TEXT, GRAPHICS, CODE AND/OR SOFTWARE UNLESS OTHERWISE NOTED ON THE SITE. You also grant
          to SOUBUL ACADEMY the right to use your name in connection with the submitted materials and other information
          as well as in connection with all advertising, marketing and promotional material related thereto.
        </span>

        <span className="block mb-4 font-semibold">2. Trademarks</span>
        <span className="block mb-6 text-sm">
          SOUBUL ACADEMY web site, publications, products, content, or services referenced herein or on the Site are the
          exclusive trademarks or service marks of SOUBUL ACADEMY including the “look” of the Site, color combinations,
          layout, and all other graphical elements. Any use of SOUBUL ACADEMY trademarks is strictly prohibited without
          the express permission from SOUBUL ACADEMY.
        </span>

        <span className="block mb-4 font-semibold">3. Use of the Site</span>
        <span className="block mb-6 text-sm">
          You understand that SOUBUL ACADEMY cannot and does not guarantee or warrant that files available for
          downloading through the Site will be free of infection or viruses, worms, Trojan horses, or other code that
          manifest contaminating or destructive properties. You are responsible for implementing sufficient procedures
          and checkpoints to satisfy your requirements for accuracy of data input and output, and for maintaining a
          means external to the Site for the reconstruction of any lost data.
        </span>

        <span className="block mb-4 font-semibold">
          In connection with your use of the Site, you agree you will not do any of the prohibitions, including, but not
          limited to:
        </span>
        <span className="block mb-6 text-sm">
          a) Transmit any message, information, data, text, software or images, or other content (“Material”) that is
          unlawful, harmful, threatening, abusive, harassing, tortuous, defamatory, vulgar, obscene, libelous, or
          otherwise objectionable that may invade another’s right of privacy or publicity;
          <br />
          b) Impersonate any person or entity or falsely state or otherwise misrepresent your affiliation with a person
          or entity of Club Z! Inc. and Club Z! Inc. LLC;
          <br />
          c) Post or transmit any Material that you do not have a right to reproduce, display or transmit under any law
          or under contractual or fiduciary relationships (such as nondisclosure agreements);
          <br />
          d) Post or transmit any Material that contains a virus or corrupted data;
          <br />
          e) Delete any author attributions, legal notices or proprietary designations or labels that you upload to any
          communication feature;
          <br />
          f) Use the Site’s communication features in a manner that adversely affects the availability of its resources
          to other users (e.g., excessive shouting, use of all caps, or flooding continuous posting of repetitive text);
          <br />
          g) Post or transmit any unsolicited advertising, promotional materials, “junk mail”, “spam,” “chain letters,”
          “pyramid schemes” or any other form of solicitation or any non-resume information such as opinions or notices,
          commercial or otherwise;
          <br />
          h) Violate any applicable local, municipal, provincial, national or international law;
          <br />
          i) Upload, transmit, embed or post a link to any Material that infringes any patent, trademark, trade secret,
          copyright or other proprietary rights of any party;
          <br />
          j) Delete or revise any Material posted by any other person or entity;
          <br />
          k) Manipulate or otherwise display the Site by using framing or similar navigational technology, or
          <br />
          l) Register with a false identity or identities for the purpose reviewing or rating either your or other
          businesses listing.
        </span>

        <span className="block mb-4 font-semibold">COMMERCIAL TRANSACTION</span>
        <span className="block mb-4 text-sm">
          By using the website or the application, you understand and agree to the commercial transaction policy of the
          user and the service provider:
        </span>

        <span className="block mb-4 font-semibold">A- User:</span>
        <span className="block mb-4 text-sm">
          • The process of accepting the selected service provider is the responsibility of the user.
          <br />
          • The price presented on the site/platform is per hour.
          <br />
          • If the user chooses one of the economic or subscription packages, which are specified for a specific total
          of hours, the user is obligated to attend for this number, and in the case of attending less than that, the
          hours benefited from are calculated at the basic service price.
          <br />
          • The service provider has the right to apologize for completing the service or cancel it if the user does not
          commit to the service provider at the agreed time, and the user will be fully charged with service fee.
          <br />• SOUBUL ACADEMY has the right to stop the user from completing with the service provider whenever the
          user is unable to pay after the service is provided.
        </span>

        <span className="block mb-4 font-semibold">B- Service provider:</span>
        <span className="block mb-4 text-sm">
          • Service providers joining the site is the responsibility of the SOUBUL ACADEMY. SOUBUL ACADEMY is keen to
          choose the best service providers to provide the service.
          <br />
          • SOUBUL ACADEMY takes a commission from the service provider according to the agreement to provide the
          service.
          <br />
          • Preserving the privacy of the parties and not disclosing any confidential information or using for any
          purpose outside the scope of service.
          <br />
          • Providing correct information, and if it is found otherwise, it is subject to suspension.
          <br />
          • Failure to assist the user with cheating and solving duties and projects.
          <br />
          • SOUBUL ACADEMY has the right to suspend the service provider from completing with the user if the service
          provider does not commit to the user at the agreed time, and the provider will be charged a fine equivalent to
          the value of the service as compensation.
          <br />
          • SOUBUL ACADEMY has the right to change the service provider with the user whenever the user wants to change
          the service provider and withdraw.
          <br />
          • SOUBUL ACADEMY has the right to suspend the service provider if the service provider does not commit to
          providing SOUBUL ACADEMY with teaching hours and information on an ongoing basis for each request.
          <br />• If the user wants to request another material or increase the number of hours with the service
          provider himself, the service provider is obligated to complete the request through the site, and if knowledge
          means not to cooperate in this, it is entitled to stop the service provider and will be charged a fine of ten
          thousand riyals for each user.
        </span>

        <span className="block mb-4 font-semibold">6.Fees and refunds:</span>
        <span className="block mb-4 text-sm">
          1- All prices displayed on the site and the APP are final prices unless there are offers or discounts.
          <br />
          2- SOUBUL ACADEMY does not receive transfers or payment of fees except on its unified official account or
          through the available payment methods.
          <br />
          3- If the user wants to withdraw from the subscription after more than two weeks have passed, he is not
          entitled to demand a refund or postponement of the subscription.
          <br />
          4- SOUBUL ACADEMY has the right to freeze any subscription at any time and to recover part of the subscription
          value for the customer. The amount refund is determined by the platform according to the number of services
          that have been used.
        </span>

        <span className="block mb-4 font-semibold">7. Termination</span>
        <span className="block mb-4 text-sm">
          Either party without notice may terminate this Agreement at any time for any reason. The provisions of
          paragraphs 1 (Copyright, Licenses, and Idea Submissions), 3 (Use of the Site), shall survive any termination
          of this Agreement.
        </span>

        <span className="block mb-4 font-semibold">8. Special Admonitions for International Use</span>
        <span className="block mb-4 text-sm">
          Recognizing the global nature of the Internet, you agree to comply with all local rules including, without
          limitation, rules about the Internet, data, e-mail, or privacy. Specifically, you agree to comply with all
          applicable laws regarding the transmission of technical data exported from the country in which you reside.
        </span>

        <span className="block mb-4 font-semibold">9.Links</span>
        <span className="block mb-4 text-sm">
          The Site may provide, or third parties may provide, links to Internet World Wide Web sites or resources.
          Because SOUBUL ACADEMY has no control over such sites and resources, you acknowledge and agree that SOUBUL
          ACADEMY is not responsible for the availability of such external sites or resources and does not endorse and
          is not responsible or liable for any content, advertising, products, or other materials on or available from
          such sites or resources. You further acknowledge and agree that SOUBUL ACADEMY shall not be responsible or
          liable, directly, or indirectly, for any damage or loss caused or alleged to be caused by or in connection
          with use of or reliance on any such content.
        </span>

        <span className="block mb-4 font-semibold">10. Miscellaneous</span>
        <span className="block mb-4 text-sm">
          This Agreement shall all be governed and construed in accordance with the country in which you reside. You
          agree that any legal action or proceeding between SOUBUL ACADEMY and you for any purpose concerning this
          Agreement or the parties’ obligations hereunder shall be brought exclusively in a municipal, provincial, or
          federal court.
        </span>

        <span className="block mb-4 font-semibold">11. Security</span>
        <span className="block mb-4 text-sm">
          This site relies on the security provided by our host and the author(s) of the software we use to protect
          against the loss, misuse, or alteration of the information under our control. We also take any steps we can if
          we are made aware of any security holes to get them fixed but we cannot guarantee complete security.
        </span>

        <span className="block mb-4 font-semibold">12. Use by Minors Prohibited</span>
        <span className="block mb-4 text-sm">
          SOUBUL ACADEMY is not intended for and should not be used by anyone under the age of 18. In the case of using
          the app those who under the legal age, the entire responsibility rests on the guardian as if he were the user.
        </span>

        <span className="block mb-4 font-semibold">13. Clients (Users, Service Providers)</span>
        <span className="block mb-4 text-sm">
          Clients who have registered to use our services can change or update their account information and preferences
          by visiting your account page.
        </span>

        <span className="block mb-4 font-semibold">14. Newsletters and Commercial Electronic Messages</span>
        <span className="block mb-4 text-sm">
          You agree to receive SOUBUL ACADEMY newsletter containing news, updates, and promotions regarding SOUBUL
          ACADEMY products or services. You can withdraw your consent by unsubscribing at any time.
        </span>

        <span className="block mb-4 font-semibold">15. Changes to Our Policies</span>
        <span className="block mb-4 text-sm">
          SOUBUL ACADEMY’ Terms of Use may change from time to time. If we make any substantive changes to our policies,
          we will notify you by sending e-mail to the address provided by you, or by posting notice of changes to this
          Web site. Your use of the site after the changes constitutes your agreement about information collected from
          you in the past and in the future.
        </span>

        <span className="block mb-4 font-semibold">16. Contacting Us</span>
        <span className="block mb-4 text-sm">
          If you have any questions about this Terms of Use Statement, the practices of SOUBUL ACADEMY, or your dealings
          with this Web site, you can contact us on Support@Soubul.com.
        </span>
      </div>
    </div>
  );
}

function ArabicTermsOfService() {
  return (
    <div className="bg-white border rounded-lg text-center my-12 px-6 py-12">
      <h1 className="text-3xl mb-12">الأحكام والشروط</h1>
      <div className="container mx-auto text-justify" style={{maxWidth: '720px'}}>
        <span className="font-semibold block mb-4">الأحكام والشروط</span>
        <span className="font-semibold block mb-4">اتفاقية مستخدم موقع الإلكتروني لأكاديمية سبل</span>
        <span className="font-semibold block mb-4">
          يرجى قراءة الشروط والأحكام بعناية قبل الوصول إلى SOUBUL.COM أو استخدامها أو استخدام التطبيقات الخاصة بها.
        </span>
        <span className="block mb-6 text-sm">
          بالوصول إلى الموقع أو استخدامه، فإنك توافق على الالتزام بالشروط والأحكام الموضحة أدناه. إذا كنت لا ترغب في
          الالتزام بهذه الشروط والأحكام، فلا يجوز لك الوصول إلى الموقع أو استخدامه ويجب أن تتوقف على الفور عن هذا
          الاستخدام. يجوز لأكاديمية سبل تعديل هذه الاتفاقية في أي وقت، وستكون هذه التعديلات سارية فور نشر الاتفاقية
          المعدلة على الموقع. وستكون مراجعة الاتفاقية بشكل دوري هي مسؤوليتك لتكون على دراية بهذه التعديلات، ويعتبر وصولك
          أو استخدامك المستمر للموقع هي موافقتك النهائية على الاتفاقية المعدلة.
        </span>

        <span className="font-semibold block mb-4">مصطلحات أساسية</span>
        <span className="block mb-6 text-sm">
          تعريف لبعض المصطلحات التي يمكن أن ترد في هذه الشروط والأحكام مالم يقتضي سياق بنود الشروط والأحكام غير ذلك:
        </span>

        <span className="block mb-6 text-sm">
          أكاديمية سبل: هو منصة مملوكة بالكامل لشركة أكاديمية سبل المحدودة، والتي تعنى بتوفير خدمات للباحثين عن الدروس
          المساندة من مقدمي الخدمة. المستخدم: هو الباحث عن خدمات الدروس المساندة. مقدم الخدمة: هو مقدم خدمات الدروس
          المساندة. الطرف الثالث: هو أي وسيط إعلامي، أو تجاري، أو دعائي، أو أي شركة، أو جهة حكومية، أو خاصة ترتبط مع
          موقع أكاديمية سبل بعقود لتوريد خدمات أو الحصول عليها أو عمل دعاية وإعلان أو أنشطة أو أي ما من شأنه أن يسهم في
          خدمات موقع أكاديمية سبل السابق تعريفها في نفس هذا البند. توثيق البيانات لكي نتمكن من توثيق رقم جوالك، كما تنص
          عليه شروط الاستخدام الظاهرة عند تسجيلك للمرة الأولى على موقع أكاديمية سبل، سيطلب منك إدخال اسم مستخدم ورقم
          الجوال وعنوان بريد إلكتروني مفعّل. بعدها سترسل رسالة نصية لرقم جوالك مع رمز التفعيل. عند الضغط على هذا الرابط
          سيتم توثيق رقم الجوال وعنوان البريد الإلكتروني الخاص بك مباشرة وسيتم إعادة توجيهك إلى موقع أكاديمية سبل.
        </span>
        <span className="block mb-6 text-sm">
          1. حقوق النشر والتراخيص وتقديم الأفكار تحمي قوانين حقوق النشر والعلامات التجارية المحلية والدولية محتويات
          الموقع بالكامل. إن مالكي حقوق الملكية الفكرية وحقوق النشر والعلامات التجارية هم أكاديمية سبل أو الشركات
          التابعة لها أو المرخصين الآخرين. لا يجوز لك تعديل المواد الموجودة على الموقع، أو نسخها أو إعادة إنتاجها أو
          إعادة نشرها أو تحميلها أو نشرها أو إرسالها أو توزيعها بأي طريقة، بما في ذلك النصوص والرسومات و / أو الكود و /
          أو البرنامج ما لم يتم توضيح ذلك على الموقع. أنت تمنح أيضًا لـأكاديمية سبل. الحق في استخدام اسمك وبياناتك فيما
          يتعلق بالمواد المقدمة والمعلومات الأخرى وكذلك فيما يتعلق بجميع المواد الإعلانية والتسويقية والترويجية المتعلقة
          بها.
        </span>

        <span className="block mb-6 text-sm">
          2. العلامات التجارية أكاديمية سبل، موقع الويب، أو المنشورات أو المنتجات أو المحتوى أو الخدمات المشار إليها هنا
          أو على الموقع هي علامات تجارية حصرية أو علامات خدمة خاصة بـ أكاديمية سبل.، بما في ذلك شكل الموقع، ومجموعات
          الألوان، والتخطيط، وجميع العناصر الرسومية الأخرى. أي استخدام لـلعلامات التجارية الخاصة بأكاديمية سبل ممنوعة
          تمامًا دون إذن صريح منها خطياً.
        </span>

        <span className="block mb-6 text-sm">
          3. استخدام الموقع أنت تدرك أن أكاديمية سبل لا تضمن أن الملفات المتاحة للتنزيل عبر الموقع ستكون خالية من
          الفيروسات أو أي تعليمات برمجية أخرى تظهر خصائص ملوثة أو مدمرة. أنت مسؤول عن تنفيذ الإجراءات ونقاط التفتيش
          الكافية لتلبية متطلباتك الخاصة لدقة إدخال البيانات ومخرجاتها، والحفاظ على وسيلة خارج الموقع لإعادة بناء أي
          بيانات مفقودة. فيما يتعلق باستخدامك للموقع، فإنك توافق على أنك لن تقوم بتاتا بأي من المحظورات وهي على سبيل
          المثال لا الحصر: أ) نقل أي رسالة، معلومات، بيانات، نصوص، أو برامج، أو صور، أو أي محتوى آخر ("المادة") غير
          قانوني، أو ضار، أو تهديد أو مسيء أو مضايق أو ملتوي أو تشهيري أو مبتذل أو فاحش أو تشهيري أو غير مرغوب فيه
          بطريقة أخرى قد تنتهك حق الآخرين في الخصوصية أو الدعاية؛ ب) انتحال شخصية أي شخص، أو كيان، أو الدولة بشكل خاطئ،
          أو تحريف ارتباطك بشخص، أو كيان من أكاديمية سبل؛ ج) نشر أو نقل أي مادة لا يحق لك نسخها أو عرضها أو نقلها بموجب
          أي قانون أو بموجب علاقات تعاقدية أو ائتمانية (مثل اتفاقيات عدم الإفشاء)؛ د) نشر أو نقل أي مادة تحتوي على فيروس
          أو بيانات تالفة؛ هـ) حذف أي إسناد للمؤلف، أو إخطارات قانونية، أو تعيينات، أو ملصقات خاصة تقوم بتحميلها إلى أي
          ميزة اتصال؛ و) استخدام ميزات الاتصال بالموقع بطريقة تؤثر سلبًا على توفر موارده للمستخدمين الآخرين (على سبيل
          المثال، الصراخ المفرط أو استخدام جميع الأحرف الاستهلالية أو إغراق النشر المستمر للنص المتكرر)؛ ز) نشر أو نقل
          أي إعلانات غير مرغوب فيها أو مواد ترويجية أو "بريد غير مرغوب فيه" أو "بريد عشوائي" أو "رسائل متسلسلة" أو
          "مخططات هرمية" أو أي شكل آخر من أشكال الالتماس أو أي معلومات غير متعلقة بالسيرة الذاتية مثل الآراء، أو
          الإشعارات، أو التجارية، أو غير ذلك؛ ح) انتهاك أي قانون محلي، بلدي، إقليمي، وطني، أو دولي معمول به؛ ط) تحميل،
          نقل، تضمين أو نشر رابط إلى أي مادة تنتهك أي براءة اختراع، أو علامة تجارية، أو سر تجاري، أو حقوق نشر ،أو حقوق
          ملكية أخرى لأي طرف؛ ي) حذف أو مراجعة أي مادة نشرها أي شخص أو كيان آخر؛ ك) التلاعب بالموقع أو عرضه بطريقة أخرى
          باستخدام تقنية تأطير أو تقنية ملاحية مماثلة، أو ل) التسجيل بهوية أو هويات مزيفة لغرض مراجعة أو تصنيف قائمة
          الأنشطة التجارية الخاصة بك أو غيرها.
        </span>
        <span className="block mb-6 text-sm">
          5. التعامل التجاري: باستخدام الموقع او التطبيق فأنت تفهم وتوافق على سياسة التعامل التجاري للمستخدم ومقدم
          الخدمة: المستخدم: عملية الموافقة على مقدم الخدمة هي مسؤولية المستخدم. السعر المقدم في الموقع/المنصة يكون
          للساعة الواحدة. في حالة اختيار المستخدم لأحد الباقات الاقتصادية أو باقات الاشتراك والتي تحدد بمجموع معين من
          الساعات، يلتزم المستخدم بالحضور لهذا العدد، وفي حالة حضور أقل من ذلك تحسب الساعات المستفاد منها بسعر الخدمة
          الأساسي. يحق لمقدم الخدمة الاعتذار عن اكمال تقديم الخدمة أو إلغائها إذا لم يقم المستخدم بالالتزام مع مقدم
          الخدمة بالوقت المتفق عليه مع تحمل طالب الخدمة للتكلفة كاملة. يحق لأكاديمية سبل إيقاف المستخدم عن الإكمال مع
          مقدم الخدمة متى ما تعذر على المستخدم الدفع بعد اكتمال تقديم الخدمة. مقدم الخدمة: انضمام مقدمي الخدمة للموقع هي
          مسؤولية أكاديمية سبل، وأكاديمية سبل تحرص على اختيار أفضل مقدمي الخدمة لتقديم الخدمة. تقوم أكاديمية سبل بأخذ
          عمولة من مقدم الخدمة حسب الاتفاق لتقديم الخدمة. المحافظة على خصوصية الطرفين وعدم إفشاء أي معلومات سرية أو
          استخدامها لأي غرض خارج نطاق الخدمة. تزويد معلومات صحيحة وفي حال تبين خلاف ذلك يكون معرض للإيقاف. عدم مساعدة
          المستخدم بالغش وحل الواجبات والمشاريع. يحق لأكاديمية سبل إيقاف مقدم الخدمة عن الاكمال مع المستخدم إذا لم يقم
          مقدم الخدمة بالالتزام مع المستخدم بالوقت المتفق عليه مع تحمله غرامة تعادل قيمة الخدمة كتعويض. يحق لأكاديمية
          سبل تغيير مقدم الخدمة مع المستخدم متى ما أراد المستخدم تغيير مقدم الخدمة والانسحاب. يحق لأكاديمية سبل إيقاف
          مقدم الخدمة إذا لم يلتزم مقدم الخدمة بتزويد أكاديمية سبل بالساعات المدرسة والمعلومات بشكل مستمر لكل طلب. في
          حالة أراد المستخدم طلب مادة أخرى أو زيادة عدد الساعات مع مقدم الخدمة نفسه، يلتزم مقدم الخدمة بإكمال الطلب عن
          طريق الموقع، وفي حالة علم سبل المعرفة بعدم التعاون في ذلك يحق لها إيقاف مقدم الخدمة وتغريمه مبلغ ١٠ آلاف ريال
          عن كل مستخدم.
        </span>
        <span className="block mb-6 text-sm">
          6. الرسوم والاسترجاع 1- جميع الأسعار المعروضة في الموقع والتطبيقات هي أسعار نهائية مالم تكن هناك عروض أو
          تخفيضات. 2- أكاديمية سبل لا تستقبل حوالات أو سداد للرسوم إلا على حسابها الرسمي الموحد أو عن طريق طرق الدفع
          المتاحة. 3-في حال أراد المستخدم الانسحاب من الاشتراك بعد مرور أكثر من أسبوعين أو الاستفادة من درس واحد على
          الأقل فإنه لا يحق له المطالبة باسترجاع القيمة أو تأجيل الاشتراك. 4- يحق لأكاديمية سبل تجميد أي اشتراك في أي
          وقت واسترجاع جزء من قيمة الاشتراك للعميل ويتم تحديد المبلغ المسترجع من طرف المنصة حسب عدد الخدمات التي تم
          الاستفادة منها وبحسب تقديرها.
        </span>
        <span className="block mb-6 text-sm">
          7. الإنهاء يجوز لأي من الطرفين دون سابق إنذار إنهاء هذه الاتفاقية في أي وقت ولأي سبب. ستظل أحكام الفقرات 1
          (حقوق النشر والتراخيص وتقديم الأفكار) و3 (استخدام الموقع) سارية بعد أي إنهاء لهذه الاتفاقية. 8. نصائح خاصة
          للاستخدام الدولي اعترافًا بالطبيعة العالمية للإنترنت، فإنك توافق على الامتثال لجميع القواعد المحلية بما في
          ذلك، على سبيل المثال لا الحصر، القواعد المتعلقة بالإنترنت، أو البيانات، أو البريد الإلكتروني أو الخصوصية. على
          وجه التحديد، أنت توافق على الامتثال لجميع القوانين المعمول بها فيما يتعلق بنقل البيانات الفنية المصدرة من
          البلد الذي تقيم فيه.
        </span>
        <span className="block mb-6 text-sm">
          9. الروابط قد يوفر الموقع، أو قد توفر جهات خارجي، روابط مواقع الإنترنت العالمية. لأن أكاديمية سبل ليس لديها
          سيطرة على مثل هذه المواقع والموارد، أنت تقر وتوافق على أن أكاديمية سبل غير مسؤولة عن توفر مثل هذه المواقع أو
          الموارد الخارجية، ولا تصادق على أي محتوى، أو إعلان، أو منتجات أو مواد أخرى أو متاحة من هذه المواقع أو الموارد
          وليست مسؤولة عنها. أنت تقر وتوافق كذلك على أن أكاديمية سبل غير مسؤولة بشكل مباشر أو غير مباشر، عن أي ضرر أو
          خسارة ناتجة أو يُزعم أنها ناجمة عن أو فيما يتعلق باستخدام أو الاعتماد على أي محتوى أو سلع أو خدمات متاحة على
          أو من خلال أي موقع أو مورد من هذا القبيل.
        </span>
        <span className="block mb-6 text-sm">
          10. متفرقات تخضع جميع هذه الاتفاقية وتفسر وفقًا لقوانين البلد الذي يقيم فيه. أنت توافق على أن أي إجراء قانوني
          أو إجراء بين أكاديمية سبل وبينك أنت لأي غرض يتعلق بهذه الاتفاقية أو التزامات الأطراف بموجب هذه الاتفاقية سيتم
          رفعها حصريًا إلى محكمة بلدية أو إقليمية.
        </span>
        <span className="block mb-6 text-sm">
          11. الأمان يعتمد هذا الموقع على الأمان الذي يوفره مضيفنا ومؤلف (مؤلفو) البرنامج الذي نستخدمه للحماية من فقدان
          المعلومات الموجودة تحت سيطرتنا أو إساءة استخدامها أو تغييرها. نتخذ أيضًا أي خطوات يمكننا اتخاذها إذا علمنا
          بوجود ثغرات أمنية لإصلاحها، ولكن لا يمكننا ضمان الأمان الكامل.
        </span>
        <span className="block mb-6 text-sm">
          12. يحظر استخدام القصر أكاديمية سبل ليست مخصصة ولا ينبغي استخدامها من قبل أي شخص يقل عمره عن 18 عامًا وفي حالة
          استخدام من هم دون السن القانوني فالمسؤولية كاملة تقع على عاتق ولي الأمر كما لو كان هو المستخدم.
        </span>
        <span className="block mb-6 text-sm">
          13. العملاء (المستخدمين/ مقدمي الخدمة) يمكن للعملاء الذين سجلوا من أجل استخدام خدماتنا تغيير أو تحديث معلومات
          حسابهم وتفضيلاتهم من خلال زيارة صفحة حسابك.
        </span>
        <span className="block mb-6 text-sm">
          14. الرسائل الإخبارية والرسائل الإلكترونية التجارية أنت توافق على استلام النشرة الإخبارية الخاصة بأكاديمية سبل
          والتي تحتوي على الأخبار والتحديثات والعروض الترويجية بخصوص منتجات أو خدمات أكاديمية سبل. ويمكنك سحب موافقتك عن
          طريق إلغاء الاشتراك في أي وقت.
        </span>
        <span className="block mb-6 text-sm">
          15. التغييرات في سياساتنا قد تتغير شروط الاستخدام لأكاديمية سبل من وقت لآخر. وإذا قمنا بإجراء أي تغييرات
          جوهرية على سياساتنا فسنخطرك عن طريق إرسال بريد إلكتروني إلى العنوان الذي قدمته، أو عن طريق نشر إشعار
          بالتغييرات على هذا الموقع. يشكل استخدامك للموقع بعد التغييرات موافقتك فيما يتعلق بالمعلومات التي تم جمعها منك
          في الماضي والمستقبل.
        </span>
        <span className="block mb-6 text-sm">
          16. الاتصال بنا إذا كانت لديك أي أسئلة حول بيان الشروط والأحكام هذه، أو ممارسات أكاديمية سبل، أو التعامل مع
          موقع الويب يمكنك التواصل معنا على Support@Soubul.com.
        </span>
      </div>
    </div>
  );
}
